var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSortUp = function SvgSortUp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.925 13.6738L9.07377 13.6738C8.30198 13.6738 7.82111 14.3923 8.20999 14.9643L11.1356 19.2681C11.5215 19.8357 12.4773 19.8357 12.8632 19.2681L15.7888 14.9643C16.1777 14.3923 15.6968 13.6738 14.925 13.6738Z",
    fill: "#C3CAD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07377 10.3266L14.925 10.3266C15.6968 10.3266 16.1777 9.60821 15.7888 9.03614L12.8632 4.73238C12.4773 4.16473 11.5215 4.16473 11.1356 4.73238L8.20999 9.03614C7.82111 9.60821 8.30198 10.3266 9.07377 10.3266Z",
    fill: "#18191B"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSortUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sort-up.7c65a27ed2647611499651e1e8c7567b.svg";